import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpModule } from '@angular/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { IonicStorageModule } from '@ionic/storage';
import { Backend } from '../providers/backend.service';
import { Api } from '../providers/api.service';
import { SmsWallApp } from './app.component';
import { BulkSms } from '../providers/bulk.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { APP_BASE_HREF } from '@angular/common';

@NgModule({
  declarations: [SmsWallApp],
  imports: [
    HttpModule,
    BrowserModule,
    BrowserAnimationsModule,
    IonicModule.forRoot(SmsWallApp, {
      radioId: 0
      /*mode: 'ios'*/
    }),
    IonicStorageModule.forRoot(),
    NgbModule.forRoot()
  ],
  bootstrap: [IonicApp],
  entryComponents: [SmsWallApp],
  providers: [
    Api,
    Backend,
    BulkSms,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    { provide: APP_BASE_HREF, useValue: '/' }
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts